import { useState } from 'react';
import { Send, Loader2, CheckCircle, AlertCircle } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContactForm = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    mensaje: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    try {
      const response = await axios.post(`${API}/contacto`, formData);
      
      if (response.data.success) {
        setStatus({
          type: 'success',
          message: response.data.message
        });
        setFormData({ nombre: '', telefono: '', mensaje: '' });
      }
    } catch (error) {
      setStatus({
        type: 'error',
        message: 'Ha ocurrido un error. Por favor, inténtalo de nuevo o llámanos directamente.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact-form">
      {/* Nombre */}
      <div>
        <label htmlFor="nombre" className="block text-sm font-medium text-[#2D3748] mb-2">
          Nombre *
        </label>
        <input
          type="text"
          id="nombre"
          name="nombre"
          value={formData.nombre}
          onChange={handleChange}
          required
          minLength={2}
          maxLength={100}
          className="form-input"
          placeholder="Tu nombre"
          data-testid="contact-input-nombre"
        />
      </div>

      {/* Teléfono */}
      <div>
        <label htmlFor="telefono" className="block text-sm font-medium text-[#2D3748] mb-2">
          Teléfono *
        </label>
        <input
          type="tel"
          id="telefono"
          name="telefono"
          value={formData.telefono}
          onChange={handleChange}
          required
          minLength={9}
          maxLength={20}
          className="form-input"
          placeholder="Tu teléfono"
          data-testid="contact-input-telefono"
        />
      </div>

      {/* Mensaje */}
      <div>
        <label htmlFor="mensaje" className="block text-sm font-medium text-[#2D3748] mb-2">
          Mensaje *
        </label>
        <textarea
          id="mensaje"
          name="mensaje"
          value={formData.mensaje}
          onChange={handleChange}
          required
          minLength={10}
          maxLength={1000}
          rows={5}
          className="form-input resize-none"
          placeholder="¿En qué podemos ayudarte?"
          data-testid="contact-input-mensaje"
        />
      </div>

      {/* Status Message */}
      {status.message && (
        <div 
          className={`flex items-center gap-3 p-4 rounded-sm ${
            status.type === 'success' 
              ? 'bg-green-50 text-green-800 border border-green-200' 
              : 'bg-red-50 text-red-800 border border-red-200'
          }`}
          data-testid="contact-status-message"
        >
          {status.type === 'success' ? (
            <CheckCircle className="w-5 h-5 flex-shrink-0" />
          ) : (
            <AlertCircle className="w-5 h-5 flex-shrink-0" />
          )}
          <p>{status.message}</p>
        </div>
      )}

      {/* Submit Button */}
      <button
        type="submit"
        disabled={isSubmitting}
        className="btn-primary w-full flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
        data-testid="contact-submit-btn"
      >
        {isSubmitting ? (
          <>
            <Loader2 className="w-5 h-5 animate-spin" />
            Enviando...
          </>
        ) : (
          <>
            <Send className="w-5 h-5" />
            Enviar Mensaje
          </>
        )}
      </button>

      <p className="text-xs text-gray-500 text-center">
        Al enviar este formulario, aceptas que nos pongamos en contacto contigo.
      </p>
    </form>
  );
};

export default ContactForm;
